import { EmbedScriptEditor } from 'features/EmbedScriptEditor';
import { MainLayout } from 'layouts/MainLayout';

const EmbedScriptEditorPage = (): JSX.Element => (
	<MainLayout isFullVh>
		<EmbedScriptEditor />
	</MainLayout>
);

export default EmbedScriptEditorPage;
